import React from "react";
export default function spotify(url) {
    return (<>
        <iframe src={url} style={{width:'100%', height:'360px'}} allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
    </>)
}